<template>

<div class="text" :class="{'is-standalone': item.type === $constants.layout.type.text}">

	<div class="text-content">{{ item.text }}</div>

	<com-info :info="item.info" v-if="item.info" />

</div>

</template>

<script>

import comInfo from './Info'

export default {

	props: ['item'],

	components: {
		'com-info': comInfo
	}

}

</script>

<style scoped>

.text {
	padding: 12px 0px;
	margin-bottom: 20px;
}

.is-mobile .text {
	margin-bottom: 0px;
	padding-top: 0px;
}

.text-content {
	color: #343434;
	font-size: 20px;
	line-height: 24px;
	white-space: pre-wrap; 
	font-weight: 600;
}

.text.is-standalone .text-content {
	font-weight: 400;
}

.is-mobile .text-content {
	font-size: 14px;
	line-height: 18px;
}

</style>